module.exports = __webpack_public_path__ + "img/ice1.0ccec280.png";